import { GridReadyEvent } from "ag-grid-community";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import cx from "classnames";
import React, { PureComponent } from "react";
import { MultiSelectCellRenderer, MultiSelectEditor } from "./MultiSelectEditor";
import NumericCellEditor from "./NumericCellEditor";

import styles from "./styles.less";
import { GridTableProps } from "./typing";

const _frameworkComponents = {
  numericCellEditor: NumericCellEditor,
  multiSelectEditor: MultiSelectEditor,
  multiSelectCell: MultiSelectCellRenderer,
};

export default class GridTable<T extends object | void = {}> extends PureComponent<
  GridTableProps<T>
> {
  static defaultProps: Partial<GridTableProps<{}>> = {
    hideOverflowX: false,
    domLayout: "autoHeight",
    enableRangeSelection: true,
    stopEditingWhenGridLosesFocus: true,
    singleClickEdit: true,
  };

  onGridReady = (params: GridReadyEvent) => {
    params.api.sizeColumnsToFit();
  };

  render() {
    let {
      defaultColDef,
      extStyle,
      extClassName,
      frameworkComponents,
      hideOverflowX,
      ...props
    } = this.props;

    // Default styles and classes
    extStyle = {
      width: "100%",
      ...extStyle,
    };

    defaultColDef = {
      sortable: false,
      editable: false,
      ...defaultColDef,
    };

    frameworkComponents = {
      ..._frameworkComponents,
      ...frameworkComponents,
    };

    const className = cx(
      "ag-theme-alpine",
      ...(extClassName || "").split(/\s+/),
      hideOverflowX && styles.hideXOverflow
    );

    // Default on grid ready
    if (!props.onGridReady) {
      props.onGridReady = this.onGridReady;
    }

    return (
      <div className={className} style={extStyle}>
        <AgGridReact
          defaultColDef={defaultColDef}
          frameworkComponents={frameworkComponents}
          {...props}
        />
      </div>
    );
  }
}
